export default {
  computed: {
    cards() {
      return this.$store.getters.getCards;
    },
    card() {
      return this.cards[this.cardId] || {};
    },
    cardTemplateChildCards() {
      // isQuickCardModal is passed as a prop to the component
      return this.isQuickCardModal
        ? (this.$store.getters.getQCChildCards ?? [])
        : (this.$store.getters.getCardTemplateChildCards ?? []);
    },
    filteredChildCards() {
      const initialValue = { notArchived: [], done: [], started: [] };
      // isTemplate is passed as a prop to the component
      if (this.isTemplate) {
        initialValue.notArchived = [...this.cardTemplateChildCards];
        return initialValue;
      }
      if (!this.card?.child_card_order) return initialValue;
      return this.card.child_card_order.reduce((acc, c) => {
        let card = this.cards[c];
        if (!card) {
          card = this.card.child_cards.find((cc) => cc.id === c);
        }
        if (card && !card.archived) {
          acc.notArchived.push(c);
        }
        if (
          card &&
          (card.status === 'completed' || card.status === 'cancelled') &&
          !card.archived
        ) {
          acc.done.push(c);
        }
        if (card && card.status === 'started' && !card.archived) {
          acc.started.push(c);
        }
        return acc;
      }, initialValue);
    },
    notArchivedCards() {
      return this.filteredChildCards.notArchived;
    },
    doneCards() {
      return this.filteredChildCards.done;
    },
    startedCards() {
      return this.filteredChildCards.started;
    },
    childCardsCount() {
      return this.notArchivedCards.length;
    },
    doneCardsCount() {
      return this.doneCards.length;
    },
    startedCardsCount() {
      return this.startedCards.length / 5;
    },
    hasChildCards() {
      return this.childCardsCount > 0;
    },
  },
};
